export const SCROLL_DIRECTIONS = ["up", "right", "down", "left"];
export const defaults = {
    xAxis: {
        hasIndicators: true
    },
    yAxis: {
        hasIndicators: true
    },
    isSticky: true
};
